import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import ExportCsvButton from "@/components/ExportCsvButton";

export default function AdminMessages() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/admin/contact-messages").then(({ data }) => setList(data || []));
  }, []);

  return (
    <DashboardLayout role="admin">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-ink sm:text-3xl">Inbox</h1>
          <p className="mt-1 text-sm text-ink-soft">Messages submitted via the public contact form.</p>
        </div>
        <ExportCsvButton endpoint="contact-messages.csv" filename="jrc_contact_messages.csv" testId="messages-export-csv" />
      </div>

      <div className="space-y-3">
        {list.length === 0 ? (
          <div className="rounded-xl border border-[#E5E2DE] bg-white px-5 py-10 text-center text-sm text-ink-soft">No messages yet.</div>
        ) : list.map((m) => (
          <div key={m.id} className="rounded-xl border border-[#E5E2DE] bg-white p-5" data-testid={`message-${m.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="font-heading text-base font-semibold text-ink">{m.name}</div>
                <div className="text-xs text-ink-muted">{m.email} · {m.phone || "—"}</div>
              </div>
              <div className="text-xs text-ink-muted">{new Date(m.created_at).toLocaleString()}</div>
            </div>
            <p className="mt-3 text-sm text-ink-soft">{m.message}</p>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
